@if (isLoading) {
  <div class="d-flex justify-content-center p-y-16 p-b-32">
    <mat-spinner [diameter]="40" />
  </div>
}
<div class="new-tab" [ngStyle]="{ display: isLoading ? 'none' : 'block' }">
  <mat-tab-group
    appDragTabs
    [class]="class"
    [class]="tabs.tabStyles?.class ?? ''"
    [useDragging]="tabs.tabStyles?.useScrollBar ?? false"
    [ngClass]="{ 'scroll-tab': tabs.tabStyles?.useScrollBar }"
    [disablePagination]="tabs.tabStyles?.useScrollBar"
    [selectedIndex]="selectTabIndex"
    [animationDuration]="tabs.tabStyles?.animationDurationMs ?? 500"
    [headerPosition]="tabs.tabStyles?.isBottomTab ? 'below' : 'above'"
    [fitInkBarToContent]="tabs.tabStyles?.fitBottomBarToContent"
    (selectedTabChange)="onTabChange($event)"
    [mat-stretch-tabs]="tabs.tabStyles?.fullWidth"
  >
    @for (tab of tabContents; track tab; let index = $index) {
      @if (!tab.hidden) {
        <mat-tab [disabled]="tab.disabled">
          <ng-template mat-tab-label>
            <div
              class="new-tab-header d-flex align-items-center justify-content-center w-100 h-100 p-r-24 p-l-24"
              (click)="onTabClick(tab)"
            >
              @if (tab.icon) {
                <img height="20" [src]="tab.icon" [ngClass]="selectTabIndex === index ? 'icon-active' : ''" class="p-x-4" />
              }
              <span class="no-select" [ngStyle]="getTextStyle(selectTabIndex === index)">{{ tab.title | translate }}</span>
              @if (getBadge(tab) !== undefined) {
                <span class="tab-badge">{{ getBadge(tab) }}</span>
              }
            </div>
          </ng-template>
          <ng-template matTabContent>
            @if (selectTabIndex === index) {
              @if (routerOutlet) {
                <router-outlet></router-outlet>
              } @else if (!tab.children) {
                <div>
                  <ng-container *ngComponentOutlet="tab.tabContent?.component; inputs: tab.tabContent?.inputs"></ng-container>
                </div>
              } @else if (tab.children) {
                <div class="p-y-16 p-x-24">
                  <app-tab [tabs]="tab.children" />
                </div>
              }
            }
          </ng-template>
        </mat-tab>
      }
    }
  </mat-tab-group>
</div>
